import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Orders from '@/components/Order/Orders'
import OrderEdit from '@/components/Order/OrderEdit'
import Register from '@/components/Users/Register'
import Admin from '@/components/Admin'
import Login from '@/components/Users/Login'
import Users from '@/components/Users/Users'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/', 
      name: 'Home',      
      component: Home
    },    
    {
      path: '/:from/:size', 
      name: 'HomeAforAdds',      
      component: Home
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/orderEdit/:id',
      name: 'orderEdit',
      component: OrderEdit
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    }        
  ]})


// WEBPACK FOOTER //
// ./src/router/index.js